import { api } from "./client";

export type Model = {
  id: number;
  name: string;
  costPrice: number;
  markupAmount: number;
  sellingPrice: number;
};

export type ModelCreate = {
  name: string;
  costPrice: number;
  markupAmount: number;
};

export type Product = {
  id: number;
  modelId: number;
  modelName: string | null;
  flavor: string;
  quantity: number;
};

export type ProductCreate = {
  modelId: number;
  flavor: string;
};

export type RestockPayload = {
  productId: number;
  quantity: number;
  unitCost: number;
};

export const inventoryApi = {
  // Models
  getModels: () => api.get<Model[]>("/api/models"),
  createModel: (data: ModelCreate) => api.post<Model>("/api/models", data),
  updateModel: (id: number, data: Partial<ModelCreate>) =>
    api.put<Model>(`/api/models/${id}`, data),
  deleteModel: (id: number) => api.del<{ success: boolean }>(`/api/models/${id}`),

  // Products
  getProducts: () => api.get<Product[]>("/api/products"),
  createProduct: (data: ProductCreate) => api.post<Product>("/api/products", data),
  deleteProduct: (id: number) => api.del<{ success: boolean }>(`/api/products/${id}`),

  // Restock
  restock: (data: RestockPayload) => api.post<Product>("/api/restock", data),
};
